<template>
    <transition name="fade" mode="out-in">
        <div class="session__iframe_booking_form">
            <div class="container">
                <div class="columns fullheight is-vcentered">
                    <div class="column">
                        <div class="session__iframe_bookingform">
                            <template v-if="!active && !booked && !error">
                                <component-loading :name="'iframe'"/>
                            </template>
                            <template v-else>
                                <template v-if="active">
                                    <pop-notify
                                        ref="booknotify"
                                        :always-visible="true"
                                        :class="'pop__notify--booking'"
                                        :title-text="'Book onto session'"
                                        :content-text="sessionBookingFormRequired ? $t('ebs.sessions.show.text.pleaseCompleteTheForm') : $t('ebs.sessions.show.text.pleaseConfirmYourBooking')"
                                        :form-active="sessionBookingFormRequired"
                                        :form-fields="bookingFields"
                                        :cancel-button-active="false"
                                        :submit-button-text="$t('ebs.sessions.show.buttons.bookOnto')"
                                        :prevent-close="true"
                                        @emit-form="updateBookingFields"
                                        @emit-submit="createBooking"
                                    />
                                </template>
                                <template v-else-if="booked">
                                    <component-note :success="true">{{ $t('ebs.sessions.show.notify.youHaveBooked') }}</component-note>
                                </template>
                                <template v-else-if="error">
                                    <component-note>
                                        {{ $t('ebs.sessions.show.notify.somethingWentWrong') }}
                                        <template v-if="errorsList.length">
                                            <component-text-list :items="errorsList"/>
                                        </template>
                                    </component-note>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentNote from '@/components/default/shared/ComponentNote'
import ComponentTextList from '@/components/default/shared/ComponentTextList'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  components: {
    ComponentLoading,
    ComponentTextList,
    ComponentNote,
    PopNotify
  },
  name: 'session-iframe-bookingform',
  data () {
    return {
      active: false,
      booked: false,
      error: false,
      errorsList: []
    }
  },
  computed: {
    eventId () {
      return this.$store.getters.getEventId
    },
    sessionId () {
      return this.$store.getters.getSessionId
    },
    sessionUserBookingStatus () {
      return this.$store.getters.getSessionUserBookingStatus
    },
    sessionBookingFormRequired () {
      return this.$store.getters['getSessionBookingFormRequired']
    },
    //
    validateSelfCreateBooking () {
      return this.$store.getters.getBookingValidate
    },
    allowValidate () {
      return this.$store.getters.getSessionAllowValidate
    },
    watchComputedValidate () {
      return this.sessionId + this.eventId
    },
    //
    bookingValidate: {
      get () {
        return this.$store.getters['getBookingValidate']
      }
    },
    bookingValidateErrors: {
      get () {
        return this.$store.getters['getBookingValidateErrors']
      }
    },
    bookingValidateErrorsExtra: {
      get () {
        return this.$store.getters['getBookingValidateErrorsExtra']
      }
    },
    bookingFields: {
      get () {
        return this.$store.getters['getBookingFields']
      }
    },
    bookingSuccess: {
      get () {
        return this.$store.getters['getBookingSuccess']
      }
    }
  },
  mounted () {
    this.$store.dispatch('clearBooking')
    if (this.sessionId && this.eventId) {
      this.validateBooking()
    }
  },
  watch: {
    watchComputedValidate () {
      if (this.sessionId && this.eventId) {
        this.validateBooking()
        this.setBookingFields()
      }
    },
    bookingSuccess () {
      if (this.bookingSuccess) {
        this.$eventBus.$emit('start-loading')
        this.getEvent()
        this.getSession()
        this.$store.dispatch('clearBooking')
      }
      if (this.bookingValidate && this.sessionUserBookingStatus !== 'booked') {
        this.$refs.booknotify.closeNotify()
      }
      if (!this.bookingValidate && this.sessionUserBookingStatus === 'booked') {
        this.$refs.bookcancelnotify.closeNotify()
      }
    }
  },
  methods: {
    getEvent () {
      const eventID = this.$route.params.eventId
      this.$store.dispatch('getEvent', eventID)
    },
    getSession () {
      const sessionID = this.$route.params.sessionId
      this.$store.dispatch('getSession', sessionID)
    },
    setBookingFields () {
      this.$store.dispatch('setBookingFields')
    },
    updateBookingFields: function (data) {
      this.$store.dispatch('updateBookingFields', data)
    },
    //
    validateBooking () {
      this.$store.dispatch('validateBooking').then(response => {
        this.active = true
        if (response.status === 200) {
          this.active = true
        } else {

        }
      }).catch(error => {
        this.errorsList = []
        const errors = error.data.data
        for (let error of errors) {
          this.errorsList.push(error.name)
        }
        if (error.data.data.find(error => error.name === 'BookingValidatorLearnerAlreadyBooked')) {
          this.active = false
          this.booked = true
        } else {
          this.active = false
          this.error = true
        }
      })
    },
    createBooking () {
      this.$store.dispatch('createBooking').then(() => {
        parent.postMessage('booked', '*')
        this.active = false
        this.booked = true
      })
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/_sessioniframebookingform.scss";
</style>
